// Arabic translations, keyed by the English text (see ./index.jsx).
// Split by area into ./ar/*.js and merged here.
const parts = import.meta.glob('./ar/*.js', { eager: true })
const ar = {}
for (const mod of Object.values(parts)) Object.assign(ar, mod.default)
export default ar
